module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nlet disabled = false\nif(!!formMapping && !!formMapping.fieldConfig) {\ndisabled = !!formMapping.fieldConfig.disabled\n}\nconst fieldConfig = model.config || {}\nconst nrOfElements = model.nrOfElements || 0\nconst showSelection = fieldConfig.showSelection === true || (fieldConfig.showSelection !== false && !fieldConfig.multiSelect)\n%><div data-field-code=\"<%- model.fieldCode || '' %>\" class=\"<%- (disabled ? 'disabled' : '') %>\"><%\n%><div class=\"top\"><%\nif(fieldConfig.showSummary !== false){\nif(fieldConfig.multiSelect){\n%><div class=\"summary\"><%= storage.__('form.fields.routePicker.summary.multi', { nrOfElements }); %></div><%\n} else if(nrOfElements > 0) {\n%><div class=\"summary\"><%= storage.__('form.fields.routePicker.summary.single.selected'); %></div><%\n} else {\n%><div class=\"summary\"><%= storage.__('form.fields.routePicker.summary.single.empty'); %></div><%\n}\n}\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'assign', context: 'routes' } }); %><%\nif((fieldConfig.showExtendedControls || {}).selected !== false){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'assign', mode: 'selected', context: 'routes', symbolOnly: true } }); %><%\n}\nif((fieldConfig.showExtendedControls || {}).reset){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'assign', mode: 'reset', context: 'routes', symbolOnly: true } }); %><%\n}\nif((fieldConfig.showExtendedControls || {}).empty !== false){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'assign', mode: 'empty', context: 'routes', symbolOnly: true } }); %><%\n}\n%></div><%\nif(showSelection){\n%><div class=\"bottom\"><%\nfor(const dataIndex in model.dataJSON || {}){\nconst {\nurl,\n} = model.dataJSON[dataIndex] || {}\nif(url){\n%><div class=\"route\"><%\n%><div class=\"text\" title=\"<%= url %>\"><%= url %></div><%\n%><%- include('../elements/buttons/default', { formMapping: { forceTag: 'a', buttonType: 'open', context: 'routes', symbolOnly: true, additionalAttributes: {\ntarget: '_blank',\nhref: `${storage.app.webService.url}${url}`\n}}}) %><%\n%></div><%\n}\n}\n%></div><%\n}\n%></div>"
  , __filename = "..\\frontend-controller\\baseComponents\\form\\fields\\route-picker-button.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
let disabled = false
if(!!formMapping && !!formMapping.fieldConfig) {
disabled = !!formMapping.fieldConfig.disabled
}
const fieldConfig = model.config || {}
const nrOfElements = model.nrOfElements || 0
const showSelection = fieldConfig.showSelection === true || (fieldConfig.showSelection !== false && !fieldConfig.multiSelect)

    ; __line = 9
    ; __append("<div data-field-code=\"")
    ; __append( model.fieldCode || '' )
    ; __append("\" class=\"")
    ; __append( (disabled ? 'disabled' : '') )
    ; __append("\">")
    ; 

    ; __line = 10
    ; __append("<div class=\"top\">")
    ; 
if(fieldConfig.showSummary !== false){
if(fieldConfig.multiSelect){

    ; __line = 13
    ; __append("<div class=\"summary\">")
    ; __append(escapeFn( storage.__('form.fields.routePicker.summary.multi', { nrOfElements }) ))
    ; __append("</div>")
    ; 
} else if(nrOfElements > 0) {

    ; __line = 15
    ; __append("<div class=\"summary\">")
    ; __append(escapeFn( storage.__('form.fields.routePicker.summary.single.selected') ))
    ; __append("</div>")
    ; 
} else {

    ; __line = 17
    ; __append("<div class=\"summary\">")
    ; __append(escapeFn( storage.__('form.fields.routePicker.summary.single.empty') ))
    ; __append("</div>")
    ; 
}
}

    ; __line = 20
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'assign', context: 'routes' } }) )
    ; 
if((fieldConfig.showExtendedControls || {}).selected !== false){

    ; __line = 22
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'assign', mode: 'selected', context: 'routes', symbolOnly: true } }) )
    ; 
}
if((fieldConfig.showExtendedControls || {}).reset){

    ; __line = 25
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'assign', mode: 'reset', context: 'routes', symbolOnly: true } }) )
    ; 
}
if((fieldConfig.showExtendedControls || {}).empty !== false){

    ; __line = 28
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'assign', mode: 'empty', context: 'routes', symbolOnly: true } }) )
    ; 
}

    ; __line = 30
    ; __append("</div>")
    ; 
if(showSelection){

    ; __line = 32
    ; __append("<div class=\"bottom\">")
    ; 
for(const dataIndex in model.dataJSON || {}){
const {
url,
} = model.dataJSON[dataIndex] || {}
if(url){

    ; __line = 38
    ; __append("<div class=\"route\">")
    ; 

    ; __line = 39
    ; __append("<div class=\"text\" title=\"")
    ; __append(escapeFn( url ))
    ; __append("\">")
    ; __append(escapeFn( url ))
    ; __append("</div>")
    ; 

    ; __line = 40
    ; __append( include('../elements/buttons/default', { formMapping: { forceTag: 'a', buttonType: 'open', context: 'routes', symbolOnly: true, additionalAttributes: {
target: '_blank',
href: `${storage.app.webService.url}${url}`
}}}) )
    ; __line = 43
    ; 

    ; __line = 44
    ; __append("</div>")
    ; 
}
}

    ; __line = 47
    ; __append("</div>")
    ; 
}

    ; __line = 49
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\form\fields\route-picker-button.ejs

}